import React, { useState, useEffect, Fragment } from 'react'
import { connect } from 'react-redux'
import BEMHelper from '@ynap/bem-helper'
import { MyAccountNav, PreviousPageLink } from '../'
import { ErrorBoundary } from '@ynap/error-page'
import Header from '../../Header/Header'

const bem = new BEMHelper('MyAccountNavWrapper')

export const NavContext = React.createContext()

export const MyAccountNavWrapper = (props) => {
    const {
        links,
        messages,
        location,
        children,
        params,
        nativeApp,
        fullWidthDesktop,
        fullPageHeader,
        enableStoreCredit,
        storeCreditExclusionList,
        locale,
        title,
        preTitle,
        userSummary
    } = props

    const [navigation, setNavigation] = useState({
        title,
        preTitle: preTitle || messages?.pages?.myAccountLanding?.title?.(),
    })

    useEffect(() => {
        if (title !== navigation.title) {
            setNavigation({
                ...navigation,
                title,
            })
        }
    }, [title])

    return (
        <NavContext.Provider value={{ setNavigation }}>
            <div className={bem(fullWidthDesktop ? 'wideGrid' : 'grid')}>
                {fullPageHeader && navigation.title && (
                    <Header title={navigation.title} preTitle={navigation.preTitle} className={bem('header')} />
                )}
                {!nativeApp && (
                    <Fragment>
                        {!fullWidthDesktop && (
                            <nav className={bem('navigation')}>
                                <MyAccountNav
                                    links={links.filter((link) => link.level < 2)}
                                    messages={messages}
                                    enableStoreCredit={enableStoreCredit}
                                    storeCreditExclusionList={storeCreditExclusionList}
                                    locale={locale}
                                    userSummary={userSummary}
                                />
                            </nav>
                        )}
                        <div className={bem(fullWidthDesktop ? 'previousPageDesktop' : 'previousPageLink')}>
                            <PreviousPageLink
                                links={links}
                                messages={messages}
                                location={location}
                                params={params}
                                title={fullPageHeader && navigation.title}
                            />
                        </div>
                    </Fragment>
                )}
                <section className={bem(nativeApp || fullWidthDesktop ? 'fullWidthSection' : 'section')}>
                    <ErrorBoundary
                        displayMessage={messages.errors.global()}
                        actionLabel={messages.errors.goBack()}
                        action={() => window.history.back()}
                    >
                        {children}
                    </ErrorBoundary>
                </section>
            </div>
        </NavContext.Provider>
    )
}

const MyAccountNavWrapperContainer = connect((state, props) => ({ links: props.getLinks(state, props) }))(
    MyAccountNavWrapper
)

export default MyAccountNavWrapperContainer
